import React, { useState } from "react";
import PanelLayout from "layouts/PanelLayout";
import { useLocation, useNavigate } from "react-router-dom";
import "styles/student.css";

export default function StudentTestStart() {
  const location = useLocation();
  const navigate = useNavigate();
  const test = location.state?.test;

  const [answers, setAnswers] = useState({});

  const questions = [
    {
      id: 1,
      type: "choice",
      text: "1-savol. Quyidagi variantlardan birini tanlang:",
      variants: ["Variant 1", "Variant 2", "Variant 3", "Variant 4"],
    },
    {
      id: 2,
      type: "text",
      text: "2-savol. Ushbu savolga yozib javob bering:",
    },
    {
      id: 3,
      type: "choice",
      text: "3-savol. To‘g‘ri javobni tanlang:",
      variants: ["A", "B", "C", "D"],
    },
    {
      id: 4,
      type: "text",
      text: "4-savol. Matnli javob kiriting:",
    },
  ];

  const handleChoiceChange = (qId, value) => {
    setAnswers((prev) => ({ ...prev, [qId]: value }));
  };

  const handleTextChange = (qId, value) => {
    setAnswers((prev) => ({ ...prev, [qId]: value }));
  };

  return (
    <PanelLayout>
      <div className="test-container">
        {questions.map((q) => (
          <div key={q.id} className="question-card">
            <h4>Savol - {q.id}</h4>
            <p className="question-text">{q.text}</p>

            {q.type === "choice" && (
              <div className="options-container">
                {q.variants.map((v, idx) => (
                  <label key={idx} className="option-item">
                    <input
                      type="radio"
                      name={`q-${q.id}`}
                      value={v}
                      checked={answers[q.id] === v}
                      onChange={() => handleChoiceChange(q.id, v)}
                    />
                    <span>{v}</span>
                  </label>
                ))}
              </div>
            )}

            {q.type === "text" && (
              <input
                type="text"
                className="write-input"
                placeholder="Javobni kiriting..."
                value={answers[q.id] || ""}
                onChange={(e) => handleTextChange(q.id, e.target.value)}
              />
            )}
          </div>
        ))}

        <button
          className="finish-btn big-finish"
          onClick={() =>
            navigate("/student/test/result", { state: { answers, test } })
          }
        >
          Tugatish
        </button>
      </div>
    </PanelLayout>
  );
}
